<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Agregar productos</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-stepper v-model="step" alt-labels>
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">¿Existe?</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 2" step="2">Datos web</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="3">Datos microsiga</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <v-card flat>
                                <v-card-text>
                                    <v-layout>
                                        <v-flex>
                                            <v-radio-group v-model="d.existe" column label="¿El producto ya existe en microsiga?">
                                                <v-radio label="SI" :value="true"></v-radio>
                                                <v-radio label="NO" :value="false"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                        <v-flex v-if="d.existe === false">
                                            <v-radio-group v-model="d.micro" column label="¿Crear en microsiga?">
                                                <v-radio label="SI" :value="true"></v-radio>
                                                <v-radio label="NO" :value="false"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                            <v-btn color="primary" @click="(d.existe)? step = 3 : step = 2">
                                Continuar
                            </v-btn>
                            <v-btn flat @click="step = 2">Cancelar</v-btn>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <form data-vv-scope="step2">
                                <v-card flat>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex>
                                                <v-text-field
                                                        v-model="d.descripcion"
                                                        label="Descripción"
                                                        counter="50"
                                                        :error-messages="errores.collect('descripcion')"
                                                        v-validate="'max:50|required'"
                                                        data-vv-name="descripcion"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-autocomplete
                                                        v-model="d.um"
                                                        :items="microUm"
                                                        item-value="AH_UNIMED"
                                                        item-text="AH_DESCES"
                                                        label="Unidad de medida"
                                                        :error-messages="errores.collect('um')"
                                                        v-validate="'required'"
                                                        data-vv-name="um"
                                                ></v-autocomplete>
                                            </v-flex>
                                            <v-flex>
                                                <v-select
                                                        v-model="d.item_tipo_id"
                                                        label="Tipo de item"
                                                        :items="tipos"
                                                        item-value="id"
                                                        item-text="desig"
                                                        :error-messages="errores.collect('item_tipo_id')"
                                                        v-validate="'required'"
                                                        data-vv-name="item_tipo_id"
                                                ></v-select>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                            <v-flex v-if="d.item_tipo_id === 5">
                                                <v-text-field
                                                        v-model="d.ancho"
                                                        label="Ancho"
                                                        :error-messages="errores.collect('ancho')"
                                                        v-validate="(d.item_tipo_id === 5)? 'required' : ''"
                                                        data-vv-name="ancho"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </form>
                            <v-btn color="primary" @click="guardar('step2')" v-if="!d.existe && !d.micro" :loading="loading">
                                Guardar
                            </v-btn>
                            <v-btn color="primary" @click="guardar('step2')" v-if="d.existe" :loading="loading">
                                Guardar
                            </v-btn>
                            <v-btn color="primary" @click="stepValida('step2',3)" v-if="!d.existe && d.micro" :loading="loading">
                                Continuar
                            </v-btn>
                            <v-btn flat @click="step = 1"> Cancelar</v-btn>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-card flat>
                                <v-card-text>
                                    <form data-vv-scope="step3">
                                        <v-layout row wrap>
                                            <v-flex class="text-xs-center">
                                                <!--FRIOLATINA///////////////////////////////////////////////////////////-->
                                                <v-avatar>
                                                    <img :src="'./img/iso-1.svg'"/>
                                                </v-avatar>
                                                <v-text-field
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_id_1"
                                                        label="Código"
                                                        counter="15"
                                                        :error-messages="errores.collect('micro_id_1')"
                                                        v-validate="(d.micro_id_1)?'max:15|required' : ''"
                                                        data-vv-name="micro_id_1"
                                                        @blur="traeProdData(1,d.micro_id_1)"
                                                        :loading="loadingProd['1']"
                                                        clearable
                                                ></v-text-field>
                                                <v-text-field
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_desc_1"
                                                        label="Descripción"
                                                        counter="50"
                                                        :error-messages="errores.collect('micro_desc_1')"
                                                        v-validate="(d.micro_id_1)?'max:50|required' : ''"
                                                        data-vv-name="micro_desc_1"
                                                ></v-text-field>
                                                <v-autocomplete
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_um_1"
                                                        :items="microUm"
                                                        item-value="AH_UNIMED"
                                                        item-text="AH_DESCES"
                                                        label="Unidad de medida"
                                                        :error-messages="errores.collect('micro_um_1')"
                                                        v-validate="(d.micro_id_1)?'required' : ''"
                                                        data-vv-name="micro_um_1"
                                                ></v-autocomplete>
                                                <v-autocomplete
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_grupo_1"
                                                        :items="grupos1"
                                                        item-value="BM_GRUPO"
                                                        item-text="BM_DESC"
                                                        label="Grupo"
                                                        :error-messages="errores.collect('micro_grupo_1')"
                                                        v-validate="(d.micro_id_1)?'required' : ''"
                                                        data-vv-name="micro_grupo_1"
                                                ></v-autocomplete>
                                                <v-checkbox
                                                        label="Control por lote"
                                                        v-model="d.micro_lote_1"
                                                ></v-checkbox>
                                            </v-flex>
                                            <v-divider class="mx-3" inset vertical></v-divider>
                                            <v-flex class="text-xs-center">
                                                <!--BERVILL///////////////////////////////////////////////////////////-->
                                                <v-avatar>
                                                    <img :src="'./img/iso-2.svg'"/>
                                                </v-avatar>
                                                <v-text-field
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_id_2"
                                                        label="Código"
                                                        counter="15"
                                                        :error-messages="errores.collect('micro_id_2')"
                                                        v-validate="(d.micro_id_2)?'max:15|required' : ''"
                                                        data-vv-name="micro_id_2"
                                                        @blur="traeProdData(2,d.micro_id_2)"
                                                        :loading="loadingProd['2']"
                                                        clearable
                                                ></v-text-field>
                                                <v-text-field
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_desc_2"
                                                        label="Descripción"
                                                        counter="50"
                                                        :error-messages="errores.collect('micro_desc_2')"
                                                        v-validate="(d.micro_id_2)?'max:50|required' : ''"
                                                        data-vv-name="micro_desc_2"
                                                ></v-text-field>
                                                <v-autocomplete
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_um_2"
                                                        :items="microUm"
                                                        item-value="AH_UNIMED"
                                                        item-text="AH_DESCES"
                                                        label="Unidad de medida"
                                                        :error-messages="errores.collect('micro_um_2')"
                                                        v-validate="(d.micro_id_2)?'required' : ''"
                                                        data-vv-name="micro_um_2"
                                                ></v-autocomplete>
                                                <v-autocomplete
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_grupo_2"
                                                        :items="grupos2"
                                                        item-value="BM_GRUPO"
                                                        item-text="BM_DESC"
                                                        label="Grupo"
                                                        :error-messages="errores.collect('micro_grupo_2')"
                                                        v-validate="(d.micro_id_2)?'required' : ''"
                                                        data-vv-name="micro_grupo_2"
                                                ></v-autocomplete>
                                                <v-checkbox
                                                        label="Control por lote"
                                                        v-model="d.micro_lote_2"
                                                ></v-checkbox>
                                            </v-flex>
                                            <v-divider class="mx-3" inset vertical></v-divider>
                                            <v-flex class="text-xs-center">
                                                <!--ACEROLATINA///////////////////////////////////////////////////////////-->
                                                <v-avatar>
                                                    <img :src="'./img/iso-3.svg'"/>
                                                </v-avatar>
                                                <v-text-field
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_id_3"
                                                        label="Código"
                                                        counter="15"
                                                        :error-messages="errores.collect('micro_id_3')"
                                                        v-validate="(d.micro_id_3)?'max:15|required' : ''"
                                                        data-vv-name="micro_id_3"
                                                        @blur="traeProdData(3,d.micro_id_3)"
                                                        :loading="loadingProd['3']"
                                                        clearable
                                                ></v-text-field>
                                                <v-text-field
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_desc_3"
                                                        label="Descripción"
                                                        counter="50"
                                                        :error-messages="errores.collect('micro_desc_3')"
                                                        v-validate="(d.micro_id_3)?'max:50|required' : ''"
                                                        data-vv-name="micro_desc_3"
                                                ></v-text-field>
                                                <v-autocomplete
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_um_3"
                                                        :items="microUm"
                                                        item-value="AH_UNIMED"
                                                        item-text="AH_DESCES"
                                                        label="Unidad de medida"
                                                        :error-messages="errores.collect('micro_um_3')"
                                                        v-validate="(d.micro_id_3)?'required' : ''"
                                                        data-vv-name="micro_um_3"
                                                ></v-autocomplete>
                                                <v-autocomplete
                                                        data-vv-scope="step3"
                                                        v-model="d.micro_grupo_3"
                                                        :items="grupos1"
                                                        item-value="BM_GRUPO"
                                                        item-text="BM_DESC"
                                                        label="Grupo"
                                                        :error-messages="errores.collect('micro_grupo_3')"
                                                        v-validate="(d.micro_id_3)?'required' : ''"
                                                        data-vv-name="micro_grupo_3"
                                                ></v-autocomplete>
                                                <v-checkbox
                                                        label="Control por lote"
                                                        v-model="d.micro_lote_3"
                                                ></v-checkbox>
                                            </v-flex>
                                        </v-layout>
                                    </form>
                                </v-card-text>
                            </v-card>
                            <v-btn color="primary" v-if="d.existe" @click="stepValida('step3',2)">
                                Continuar
                            </v-btn>
                            <v-btn color="primary" @click.native="guardar()" :loading="loadingMicro" v-if="!d.existe && d.micro">
                                Guardar
                            </v-btn>
                            <v-btn flat @click="step = 1">Cancel</v-btn>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import mixinItems from '../../../mixins/items';

    export default {
        name: "add",
        $_veeValidate: {
            validator: 'new'
        },
        mixins: [mixinItems],
        data() {
            return {
                loading: false,
                loadingMicro: false,
                loadingProd: {
                    '1': false,
                    '2': false,
                    '3': false
                },
                step: 0,
                tipos: [],
                microUm: [],
                grupos1: [],
                grupos2: [],
                grupos3: [],
                d: {
                    micro: false,
                    existe: false,
                    descripcion: '',
                    um: 'M2',
                    item_tipo_id: '',
                    ancho: 0,
                    micro_id_1: '',
                    micro_id_2: '',
                    micro_id_3: '',
                    micro_um_1: '',
                    micro_um_2: '',
                    micro_um_3: '',
                    micro_desc_1: '',
                    micro_desc_2: '',
                    micro_desc_3: '',
                    micro_grupo_1: '',
                    micro_grupo_2: '',
                    micro_grupo_3: '',
                    micro_locpad_1: '',
                    micro_locpad_2: '',
                    micro_locpad_3: '',
                    micro_cc_1: '',
                    micro_cc_2: '',
                    micro_cc_3: '',
                    micro_lote_1: false,
                    micro_lote_2: false,
                    micro_lote_3: false,
                    grupo: '',
                    cuenta: '11500003'
                }
            }
        },
        mounted() {
            this.traeDatos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            traeDatos() {
                this.itemTipos(r => {
                    this.tipos = r;
                }, err => {
                    console.log(err);
                });
                this.itemMicroUM(r => {
                    this.microUm = r;
                }, err => {
                    console.log(err);
                });
                this.itemMicroGrupo({empresa_id: 1}, r => {
                    this.grupos1 = r;
                }, err => {
                    console.log(err);
                });
                this.itemMicroGrupo({empresa_id: 2}, r => {
                    this.grupos2 = r;
                }, err => {
                    console.log(err);
                });
                this.itemMicroGrupo({empresa_id: 3}, r => {
                    this.grupos3 = r;
                }, err => {
                    console.log(err);
                });
            },
            guardar(step) {
                this.loading = true;
                this.loadingMicro = true;
                this.$validator.validateAll(step)
                    .then(r => {
                        if (!r) {
                            this.msjShow({tipo: 'error', txt: 'Error de validación'});
                            this.loading = false;
                            this.loadingMicro = false;
                            return false
                        }
                        this.itemStore(this.d, r => {
                            this.msjShow(r);
                            if (r.tipo !== 'error') {
                                this.limpiar();
                                this.step = 1;
                            }
                            this.loading = false;
                            this.loadingMicro = false;
                        }, err => {
                            this.msjShow({tipo: 'error', txt: 'Error al guardar'});
                            this.loading = false;
                            this.loadingMicro = false;
                        })
                    })
                    .catch(err => {
                        this.msjShow({tipo: 'error', txt: 'Error de validación'});
                        this.loading = false;
                        this.loadingMicro = false;
                    })

            },
            traeProdData(empresa_id, producto_id) {
                this.loadingProd[empresa_id] = true;
                this.itemMicroProdEmp({empresa_id: empresa_id, producto_id: producto_id}, r => {
                    this.d['micro_desc_' + empresa_id] = r.B1_DESC;
                    this.d['micro_grupo_' + empresa_id] = r.B1_GRUPO;
                    this.d['micro_um_' + empresa_id] = r.B1_UM;
                    if (r.B1_DESC) {
                        this.d.descripcion = r.B1_DESC;
                        this.d.um = r.B1_UM;
                    }
                    this.loadingProd[empresa_id] = false;
                }, err => {
                    this.loadingProd[empresa_id] = false;
                    console.log(err);
                })
            },
            limpiar() {
                this.d = {
                    micro: false,
                    existe: false,
                    descripcion: '',
                    um: 'M2',
                    item_tipo_id: '',
                    ancho: 0,
                    micro_id_1: '',
                    micro_id_2: '',
                    micro_id_3: '',
                    micro_um_1: '',
                    micro_um_2: '',
                    micro_um_3: '',
                    micro_desc_1: '',
                    micro_desc_2: '',
                    micro_desc_3: '',
                    micro_grupo_1: '',
                    micro_grupo_2: '',
                    micro_grupo_3: '',
                    micro_lote_1: false,
                    micro_lote_2: false,
                    micro_lote_3: false,
                    grupo: '',
                    cuenta: '11500003'
                };
                this.$validator.reset()
            },
            stepValida(step, irA) {
                this.$validator.validateAll(step)
                    .then(r => {
                        if (!r) {
                            this.msjShow({tipo: 'error', txt: 'Error de validación'});
                            return false;
                        }
                        this.step = irA;
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/archivo/productos/add.vue